// Centralized password configuration for tabulator access
// This allows easy password management from one location

export const TABULATOR_PASSWORD = process.env.REACT_APP_TABULATOR_PASSWORD || 'password';

// Session configuration - Extended to 8 hours for competition sessions
export const PASSWORD_SESSION_DURATION = 28800000; // 8 hours (was 2 hours)
export const SESSION_STORAGE_KEY = 'tabulatorAuth';

// Password validation function
export const validateTabulatorPassword = (inputPassword) => {
  return inputPassword === TABULATOR_PASSWORD;
};

// Session management functions
export const storeTabulatorAuth = () => {
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify({
    timestamp: new Date().toISOString(),
    authorized: true
  }));
};

export const checkTabulatorAuth = () => {
  const tabulatorAuth = sessionStorage.getItem(SESSION_STORAGE_KEY);
  const tabulatorAuthData = tabulatorAuth ? JSON.parse(tabulatorAuth) : null;
  
  // Check if password was verified recently
  const isRecentlyAuthorized = tabulatorAuthData && 
    new Date().getTime() - new Date(tabulatorAuthData.timestamp).getTime() < PASSWORD_SESSION_DURATION;
  
  return isRecentlyAuthorized;
};

export const clearTabulatorAuth = () => {
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
};
